import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";

export const DTA_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.dtaAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.dtaAwardsPage,
  },
  {
    label: "How to Apply",
    link: RouteFactory.dtaNominatePage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("design-ai-and-tech-awards"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsGallery("design-ai-and-tech-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("design-ai-and-tech-awards"),
  },
  {
    label: "Contact Us",
    link: RouteFactory.dtaContactUsPage,
  },
  {
    label: "Partners",
    link: RouteFactory.dtaPartnersPage,
  },
  {
    label: "Judges",
    link: RouteFactory.dtaJudgesPage,
  },
];

export const DTA_FOOTER_MENU_MOBILE = [
  {
    label: "About",
    link: RouteFactory.dtaAboutPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("design-ai-and-tech-awards"),
  },
  {
    label: "Awards",
    link: RouteFactory.dtaAwardsPage,
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsGallery("design-ai-and-tech-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("design-ai-and-tech-awards"),
  },
  {
    label: "How to Apply",
    link: RouteFactory.dtaNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.dtaContactUsPage,
  },
  {
    label: "Partners",
    link: RouteFactory.dtaPartnersPage,
  },
  {
    label: "Judges",
    link: RouteFactory.dtaJudgesPage,
  },
];

export const DTA_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.dtaAboutPage,
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("design-ai-and-tech-awards"),
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.dtaAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("design-ai-and-tech-awards"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("design-ai-and-tech-awards"),
    enabled: true,
  },
  {
    text: "How to Apply",
    link: RouteFactory.dtaNominatePage,
    enabled: true,
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "submissionsTab",
    label: "Submissions",
  },
  {
    key: "assessmentTab",
    label: "Assessment",
  },
  {
    key: "declarationsTab",
    label: "Declarations",
  },
];
